(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFirmwareDeleteController', TabFirmwareDeleteController);

    TabFirmwareDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabFirmware'];

    function TabFirmwareDeleteController($uibModalInstance, entity, TabFirmware) {
        var vm = this;
        vm.tabFirmware = entity;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabFirmware.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
